import { Modal } from "react-bootstrap";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    return (
        <Modal show={true} contentLabel="Example Modal" size={props.size || "xl"} className={props.modalClass || ''}
            aria-labelledby="contained-modal-title-vcenter"
            centered={props.center ? props.center : false}
        >
            <Modal.Header>
                <Modal.Title>{props.label}</Modal.Title>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={props.showHide}>
                    <span aria-hidden="true">×</span>
                </button>
            </Modal.Header>
            <Modal.Body>
                {props.children}
            </Modal.Body>
            <Modal.Footer>
            {!props.onlyClose && <button className="btn btn-primary" onClick={props.saveFunction}>{props.buttonName ? props.buttonName : 'Save changes'}</button>}
            <button className="btn btn-outline-primary" data-bs-dismiss="modal" onClick={props.showHide}>{props.closeButtonName ? props.closeButtonName : 'Close'}</button>
            </Modal.Footer>
        </Modal>
    )
}
